const teaserItems = document.querySelectorAll('.teaser-slider-item, .teaser-carousel-item');

teaserItems.forEach((teaser) => {
    const anchorElement = teaser.querySelector('a');
    if (!anchorElement) {
        return;
    }

    const link = anchorElement.getAttribute('href');

    if (!link) {
        return;
    }

    teaser.addEventListener('click', function (event) {
        window.location.href = link;
    });
});
